import Link from "next/link";
import { usePathname } from "next/navigation";

import { cn } from "~/utils/fontsConfig";
import { SidebarItem } from "../community-components/CommunitySideBar/SidebarTypes";

type Props = {
    sideBarItem: SidebarItem;
    depth: number;
    state: Map<string, boolean>;
    children: React.ReactNode;
};

export const SubNavLinkWrapper = ({
    sideBarItem,
    depth,
    state,
    children,
}: Props) => {
    const pathname = usePathname() ?? "";

    // we use path as a unique key for our state tree
    const path = `${depth}-${sideBarItem.name}`;
    const isOpen = state.has(path) ? state.get(path) : state.set(path, false);

    const normalizePath = (path?: string) => {
        return path?.replace(/^\/v3/, "");
    };

    const isSelected =
        normalizePath(pathname) === normalizePath(sideBarItem.href);

    return (
        <div>
            {sideBarItem.href ? (
                <Link
                    href={sideBarItem.href}
                    className={cn(
                        "grid grid-cols-[10%_90%] justify-center rounded-lg px-4 py-2 transition-colors duration-100 ease-in-out",
                        "text-v3-N-300 hover:cursor-pointer hover:bg-v3-N-400 hover:text-white",
                        {
                            " bg-v3-N-400 text-white":
                                isSelected && !sideBarItem.isSpecial,
                            "text-white": isOpen && !isSelected,
                            "text-v3-primary hover:bg-transparent hover:text-v3-primary":
                                sideBarItem.isSpecial,
                        },
                    )}
                >
                    {children}
                </Link>
            ) : (
                <div
                    className={cn(
                        "grid grid-cols-[10%_90%] justify-center rounded-lg px-4 py-2 transition-colors duration-100 ease-in-out",
                        "text-v3-N-300 hover:cursor-pointer hover:bg-v3-N-400 hover:text-white",
                        {
                            " bg-v3-N-400 text-white":
                                isSelected && !sideBarItem.isSpecial,
                            "text-white": isOpen && !isSelected,
                            "text-v3-primary hover:bg-transparent hover:text-v3-primary":
                                sideBarItem.isSpecial,
                        },
                    )}
                    onClick={sideBarItem.onClick}
                >
                    {children}
                </div>
            )}
        </div>
    );
};
